/**
 * PANEL-ASISTENTE-FORMATO-T1 (Ares #30623; referencias de Atenea WORK-ASISTENTE-UI-REFERENCIAS_2026-10-19, mismo formato
 * que Argemiro O / INIT-ARGEMIRO-O-001 v1.0): la respuesta de Tu asistente en tres capas.
 *
 *   1. conclusion   -> la frase de la consulta (narrative), arriba, como ya se pinta
 *   2. contexto     -> UNA linea: negocio, fuente, hora del DATO separada de la hora de la CONSULTA
 *   3. evidencia    -> plegada (la tabla/detalle que ya existe)
 *
 * Reglas de Atenea que este modulo hace cumplir:
 *   - la hora del dato no se inventa: consulta-nexo (n8n "Format Response") no trae corte -> "sin hora del dato";
 *     nunca se reemplaza por la hora de la respuesta.
 *   - incertidumbre visible: lo que n8n tomo por defecto (placeholders_defaulted) se dice.
 *   - sin datos != cero: 0 filas y sin frase se dice como "no encontre datos", no como 0 ni "sin resultados".
 *   - negocio cambiado durante la consulta: la respuesta vieja no se muestra como del negocio actual.
 * Sin DOM: lo prueba check-asistente-contexto.
 *
 * @module application/asistente/contextoDeRespuesta
 */

const hora = (d) => {
  const x = d instanceof Date ? d : new Date(d);
  return Number.isNaN(x.getTime()) ? '' : x.toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'America/Bogota' });
};

const PARAMETRO = { fecha: 'la fecha', desde: 'desde', hasta: 'hasta', dia: 'el día', mes: 'el mes', anio: 'el año', limite: 'cuántos', top: 'cuántos' };

/**
 * @param {object} d respuesta de consulta-nexo (capability_used, description, narrative, rows, params_used, placeholders_defaulted)
 * @param {{negocio?:string, consultadoEn?:Date|string, corte?:string}} o corte solo si la fuente lo trae
 */
export function contextoDeConsulta(d, { negocio = '', consultadoEn = new Date(), corte = '' } = {}) {
  const filas = Array.isArray(d?.rows) ? d.rows.length : 0;
  const fuente = String(d?.description || '').trim() || (d?.capability_used ? 'consulta de Nexo' : '');
  const corteDato = String(corte || d?.corte || d?.as_of || '').trim();
  const params = d?.params_used || {};
  const porDefecto = Array.isArray(d?.placeholders_defaulted) ? d.placeholders_defaulted : [];
  const avisos = porDefecto.map((p) => {
    const v = params[p];
    return `Tomé ${PARAMETRO[p] || p} por defecto${v !== undefined && v !== null && v !== '' ? ` (${v})` : ''}.`;
  });
  return {
    negocio: String(negocio || '').trim() || 'negocio sin nombre',
    fuente: fuente || 'fuente no informada',
    corte: corteDato || null,
    consultado: hora(consultadoEn),
    avisos,
    filas,
    vacio: filas === 0 && !String(d?.narrative || '').trim()
  };
}

/** La linea de contexto, en texto (la vista la escapa). La hora del dato y la de consulta nunca se mezclan. */
export function lineaDeContexto(c) {
  return [c.negocio, `fuente: ${c.fuente}`, c.corte ? `datos al ${c.corte}` : 'sin hora del dato', c.consultado ? `consultado ${c.consultado}` : '']
    .filter(Boolean).join(' · ');
}

export const FRASE_SIN_DATOS = 'No encontré datos para eso. Eso no quiere decir que sea cero: puede que no esté registrado.';

/** true si el negocio de la pantalla ya no es el de la consulta (la respuesta no se pinta como actual). */
export function negocioCambio(consultadoPara, actual) {
  return !!consultadoPara && !!actual && String(consultadoPara) !== String(actual);
}

export function fraseNegocioCambio(nombreAnterior) {
  return `Cambiaste de negocio mientras consultaba: no muestro esa respuesta${nombreAnterior ? ` (era de ${nombreAnterior})` : ''}. Pregúntalo otra vez si la necesitas.`;
}
